import { render } from "./InfoconnectLogo.vue?vue&type=template&id=794fe507"
import script from "./InfoconnectLogo.vue?vue&type=script&lang=js"
export * from "./InfoconnectLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__